import api from './api';

export const getProfile = () => api.get('/profile');
export const updateProfile = (data) => api.put('/profile', data);
export const changePassword = (data) => api.post('/profile/change-password', data);
export const getActivityLogs = () => api.get('/profile/activity-logs');